<section class="pdfc-history">
  <header class="header">
    <button
      mat-stroked-button
      type="button"
      class="back-button"
      (click)="goBack()"
    >
      <mat-icon>arrow_back</mat-icon>
      Back to organisation
    </button>
    <h1 class="title">Product Data Filename Convention — history</h1>
  </header>

  @if (loaded) {
    @if (rows.length === 0) {
      <div class="empty-state">
        No history yet. Configure the convention in Settings.
      </div>
    } @else {
      <table mat-table [dataSource]="rows" class="history-table">
        <ng-container matColumnDef="when">
          <th mat-header-cell *matHeaderCellDef>When</th>
          <td mat-cell *matCellDef="let row">{{ row.createdAt }}</td>
        </ng-container>

        <ng-container matColumnDef="by">
          <th mat-header-cell *matHeaderCellDef>By</th>
          <td mat-cell *matCellDef="let row">{{ row.createdByEmail }}</td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef>Filename identifier</th>
          <td mat-cell *matCellDef="let row">{{ row.identifierLabel }}</td>
        </ng-container>

        <ng-container matColumnDef="extensions">
          <th mat-header-cell *matHeaderCellDef>Extensions</th>
          <td mat-cell *matCellDef="let row">{{ row.extensionsLabel }}</td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef>Reason</th>
          <td mat-cell *matCellDef="let row">
            <div class="reason-cell">
              <span [class]="reasonPillClass(row.reasonKind)">{{ row.reasonLabel }}</span>
              @if (row.reasonDetail !== null) {
                <span class="reason-detail">{{ row.reasonDetail }}</span>
              }
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          [class.latest-row]="isLatest(i)"
        ></tr>
      </table>
    }
  }
</section>
